import { deleteProject } from './projects'

export function useDeleteProject() {
  return deleteProject
}
